module Client.Equipment
open Client.Services
open Elmish
open Fable.Core
open Fable.Core.JsInterop
open Fetch.Types
open Shared
open System
open Thoth.Json
open Feliz
open Feliz.UseElmish
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Thoth.Fetch
open Fable.Core.Experimental
open Feliz.SweetAlert
open Fable.Core.JS
open Components.ServiceForm

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some (s.Trim())

type Model =
  | EquipmentLookup
  | EquipmentNotFound
  | EquipmentFound of Equipment

type Msg =
  | EquipmentLookupResult of Result<Equipment,Components.EquipmentLookup.EquipmentLookupFailureResult>
  | EquipmentSelected of Shared.Equipment

let init () =
  EquipmentLookup, Cmd.none

let update msg (model : Model) =
  match model, msg with
  | EquipmentLookup, EquipmentLookupResult r ->
    match r with
    | Ok e -> model, Cmd.ofMsg (EquipmentSelected e)
    | Error v ->
      EquipmentNotFound, Cmd.none
  | EquipmentLookup, EquipmentSelected e ->
    EquipmentFound e, Cmd.none
  | _ -> model, Cmd.none

let view = React.functionComponent (fun (inputProps: {| reCaptchaSiteKey : string; equipmentOrSerialNumberOption : string option; |}) ->
  let model, dispatch = React.useElmish(init (),update, [| |])
  let classes = Styles.useStyles()
  let isMobile = Hooks.useMediaQuery (Client.Theme.defaultTheme.breakpoints.downSm)
  let drawerIsOpen, setDrawerIsOpen = React.useState false
  Html.div [
    Mui.cssBaseline []
    Html.div [
      prop.className [
        classes.root
      ]
      prop.children [
        Mui.cssBaseline []
        Mui.appBar [
          prop.className [
            classes.appBar
            if drawerIsOpen then classes.appBarShift
          ]
          appBar.color.default'
          appBar.position.fixed'
          appBar.children [
            Mui.toolbar [
              // Mui.iconButton [
              //   prop.className
              //     [ classes.menuButton
              //       if drawerIsOpen then classes.hide ]
              //   iconButton.edge.start
              //   iconButton.children [ menuIcon []]
              //   prop.onClick (fun _ -> setDrawerIsOpen (not drawerIsOpen))
              // ]
              Html.img  [
                prop.src "/logo.png"
              ]
              Mui.typography [
                typography.variant.h5
                prop.style [ style.flexGrow 1 ]
                typography.children [ Html.text "" ]
              ]
            ]
          ]
        ]

        Mui.drawer [
          drawer.classes.root classes.drawer
          drawer.classes.paper classes.drawerPaper
          drawer.anchor.left
          drawer.open' drawerIsOpen
          drawer.variant.persistent
          drawer.children [
            Html.div [
              prop.className classes.drawerHeader
              prop.children [
                Mui.iconButton [
                  iconButton.children [
                    if drawerIsOpen then chevronLeftIcon [] else chevronRightIcon [] ]
                  prop.onClick (fun _ -> setDrawerIsOpen false)
                ]
              ]
            ]
            Mui.divider []
            //Menu.view {| equipmentNumber = "Equipment number" |}
          ]
        ]
        Html.main [
          prop.className [
            classes.content
            if drawerIsOpen then classes.contentShift
          ]
          prop.children [
            Html.div [ prop.className classes.drawerHeader ]

            Html.div [
              Mui.grid [
                grid.container true
                grid.direction.column
                grid.spacing._2
                grid.children [
                  Mui.grid [
                    grid.item true
                    grid.children [
                      Mui.typography [
                        typography.variant.h4
                        typography.children "Equipment"
                      ]
                    ]
                  ]
                ]
              ]

              match model with
              | EquipmentLookup -> Components.EquipmentLookup.view {| reCaptchaSiteKey = inputProps.reCaptchaSiteKey; equipmentOrSerialNumberOption = inputProps.equipmentOrSerialNumberOption; returnResult = (fun e -> e |> EquipmentLookupResult |> dispatch); |}
              | EquipmentFound e -> Components.EquipmentInfo.view e
              | EquipmentNotFound -> Html.text "Equipment not found"
            ]
          ]
        ]
      ]
    ]
  ]
)